import React from 'react'
import Icon from 'components/Icon/Icon'
import styled from 'particles/themes/styled'
import Filter from './Filter'
import NavButtons from './NavButtons'
import Divider from 'components/Shared/Divider'
import Profile from './Profile'
import LanguageFilter from './LanguageFilter'

interface ExtendedNavbarProps {
    className?: string
    isExtend: boolean
    toggleClose: (value: boolean) => void
}

const ExtendedNavbar: React.FC<ExtendedNavbarProps> = ({ className, toggleClose }) => {
    const closeExtendSideBar = () => {
        toggleClose(false)
    }
    return (
        <div className={className}>
            <div>
                <div className="nav-control">
                    <Icon.FullLogoIcon height={28} />
                    <Icon.CloseIcon width={28} height={28} className="close" onClick={closeExtendSideBar} />
                </div>
                <Filter isExtend extendOnClick={closeExtendSideBar} />
                <Divider width="100%" />
                <NavButtons isExtend extendOnClick={closeExtendSideBar} />
            </div>

            <div>
                <Profile isExtend />
                <Divider width="100%" />
                <LanguageFilter isExtend />
            </div>
        </div>
    )
}

export default styled(ExtendedNavbar)`
    background-color: white;
    width: 100%;
    max-width: 768px;
    height: calc(100% - env(safe-area-inset-bottom));
    position: fixed;
    left: ${({ isExtend }) => (isExtend ? 0 : '-1000px')};
    top: 0;
    z-index: 200;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 2em 1rem 60px;
    transition: left 0.5s;
    .close {
        cursor: pointer;
    }
    .nav-control {
        width: 100%;
        display: flex;
        justify-content: space-between;
    }
`
